module.exports = __webpack_public_path__ + "media/01Dragon Boat Festival.fa7bdb18.mp3";